import { createSlice } from "@reduxjs/toolkit";
import UserModel from "../models/user/UserModel";

const initialState = {
  user: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setUserReducer(state, action) {
      state.user = action.payload;
    },
    updateUserLangReducer(state, action) {
      let newUser = new UserModel(state.user);
      newUser.setLang(action.payload);
      state.user = newUser;
    },
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setUserReducer, updateUserLangReducer } = userSlice.actions;

// Export the slice reducer as the default export
export default userSlice.reducer;
